import i18n from "../i18n";
import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";

const USERS_BASE = `${apiBaseUrl}/api/auth/users`;

async function request(
  path = "/",
  { accessToken, params, method = "GET", body } = {}
) {
  if (!accessToken) {
    throw new Error(i18n.t("errors.adminRequired"));
  }

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${accessToken}`,
    "Accept-Language": getStoredLanguage(),
  };

  if (body) {
    headers["Content-Type"] = "application/json";
  }

  const queryParams = params
    ? { ...params, lang: getStoredLanguage() }
    : { lang: getStoredLanguage() };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${USERS_BASE}${path}${queryString}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || i18n.t("errors.operationFailed");
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchUsers({ accessToken, role, search, page } = {}) {
  const params = {};
  if (role && role !== "all") {
    params.role = role;
  }
  if (search) {
    params.search = search;
  }
  if (page) {
    params.page = page;
  }
  return request("/", {
    accessToken,
    params: Object.keys(params).length ? params : undefined,
  });
}

export function updateUserRole({ accessToken, userId, role }) {
  return request(`/${userId}/role/`, {
    accessToken,
    method: "PATCH",
    body: { role },
  });
}
